import IconButton from '@mui/material/IconButton';
import AppBar from '@mui/material/AppBar';
import Fab from '@mui/material/Fab';
import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import ContactMail from '@mui/icons-material/ContactMail';
import Home from '@mui/icons-material/Home';
import Avatar from '@mui/material/Avatar';
import firebase from './firebase.js'
import { useLocation, Link } from 'react-router-dom';
import React from "react";
import './App.css';

function TopBar(props) {
  const location = useLocation();
  const analytics = firebase.analytics;
  let size = window.innerWidth;
  let browserComp = navigator.vendor;

  return (
    <div>
      <AppBar position="sticky" color="transparent"
        className={location.pathname !== "/" && browserComp !== "Apple Computer, Inc." && size > 600 ? "appbar2" : location.pathname !== "/" && browserComp !== "Apple Computer, Inc." && size <= 600 ? "appbar2mobile" : location.pathname !== "/" && size > 600 ? "appbar2Ios" : location.pathname !== "/" && size <= 600 ? "appbar2mobileIos" : "appbar"}>
        <Toolbar>
          <IconButton
            edge="start"
            color="default"
            aria-label="open drawer"
            component={Link}
            className="white"
            to="/"
          >
            <Home />
          </IconButton>

          <Stack direction="row" spacing={0.5} justifyContent="flex-end" alignItems="center" sx={{ width: '100%' }}>
            {
              (firebase.isTheUser()) ?
                <IconButton
                  aria-haspopup="true"
                  color="inherit"
                  component={Link}
                  to="/dash"
                >
                  Dash
                </IconButton>
                : ""
            }
            <IconButton
              aria-haspopup="true"
              color="inherit"
              component={Link}
              to="/projects"
            >
              Projects
            </IconButton>
            <IconButton
              aria-haspopup="true"
              color="inherit"
              component={Link}
              to="/services"
            >
              Services
            </IconButton>
            {
              (firebase.isTheUser()) ?
                <Avatar
                  onClick={logout}
                  style={{ textDecoration: "none", background: "linear-gradient(90deg, #d53369 0%, #daae51 100%)", textTransform: "uppercase" }}
                  alt={firebase.auth.currentUser.email}>
                  {firebase.auth.currentUser.email.substring(0, 2)}
                </Avatar>
                : ""
            }
          </Stack>
        </Toolbar>
      </AppBar>

      {props.minifiedBar !== "true" ?
        <Fab
          color="primary"
          variant="extended"
          className="form-button"
          href="https://forms.gle/eC66KXTDtqMRHx9T8"
          target="_blank"
        >
          <ContactMail style={{ marginRight: "0.75pc" }} />
          Contact
        </Fab>
        : ""}
    </div>
  );

  async function logout() {
    if (window.confirm("Would you like to logout?") === true) {
      try {
        await firebase.logout()
        window.location.replace('/');
      } catch (error) {
        alert(error.message)
      }
    }
    else {

    }
  }
}
export default TopBar;